"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.currenciesMessages = void 0;
var _reactIntl = require("react-intl");
const currenciesMessages = exports.currenciesMessages = (0, _reactIntl.defineMessages)({
  USD: {
    id: 'CurrencySelector.currencyName.USD',
    defaultMessage: 'US Dollar'
  },
  EUR: {
    id: 'CurrencySelector.currencyName.EUR',
    defaultMessage: 'European Euro'
  },
  JPY: {
    id: 'CurrencySelector.currencyName.JPY',
    defaultMessage: 'Japanese Yen'
  },
  GBP: {
    id: 'CurrencySelector.currencyName.GBP',
    defaultMessage: 'Pound Sterling'
  },
  CAD: {
    id: 'CurrencySelector.currencyName.CAD',
    defaultMessage: 'Canadian Dollar'
  },
  CNY: {
    id: 'CurrencySelector.currencyName.CNY',
    defaultMessage: 'Chinese Yuan Renminbi'
  },
  MXN: {
    id: 'CurrencySelector.currencyName.MXN',
    defaultMessage: 'Mexican Peso'
  },
  HKD: {
    id: 'CurrencySelector.currencyName.HKD',
    defaultMessage: 'Hong Kong Dollar'
  },
  KRW: {
    id: 'CurrencySelector.currencyName.KRW',
    defaultMessage: 'South Korean Won'
  },
  TRY: {
    id: 'CurrencySelector.currencyName.TRY',
    defaultMessage: 'Turkish Lira'
  },
  BRL: {
    id: 'CurrencySelector.currencyName.BRL',
    defaultMessage: 'Brazilian Real'
  },
  TWD: {
    id: 'CurrencySelector.currencyName.TWD',
    defaultMessage: 'New Taiwan Dollar'
  },
  AUD: {
    id: 'CurrencySelector.currencyName.AUD',
    defaultMessage: 'Australian Dollar'
  },
  CZK: {
    id: 'CurrencySelector.currencyName.CZK',
    defaultMessage: 'Czech Koruna'
  },
  DKK: {
    id: 'CurrencySelector.currencyName.DKK',
    defaultMessage: 'Danish Krone'
  },
  PLN: {
    id: 'CurrencySelector.currencyName.PLN',
    defaultMessage: 'Polish Zloty'
  },
  SEK: {
    id: 'CurrencySelector.currencyName.SEK',
    defaultMessage: 'Swedish Krona'
  }
});